<template>
    <div>
        <b-input-group>
            <b-form-input disabled :value="fileName"></b-form-input>
            <b-input-group-append>
                <b-button
                    title="Load file"
                    :href="documentUrl"
                    target="_blank"
                    :disabled="!value"
                >
                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                </b-button>
                <b-button
                    v-if="!disabled"
                    @click="is_visible = true"
                    variant="outline-primary"
                >
                    <b-icon icon="cloud-upload"></b-icon>
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <b-modal :id="uploadKey" v-model="is_visible" title="Upload Document">
            <b-form-file id="uploadData" @change="uploadFile"></b-form-file>
        </b-modal>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [popupMixins],
    data() {
        return {
            key: null,
            fileName: null,
            is_visible: false,
            uploadKey: 0,
        }
    },

    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        documentUrl() {
            return `${this.$OMSStorageUrl}/${this.key}`
        },
    },
    watch: {
        is_visible: function (val) {
            console.log('is_visible', val)
            if (!val) this.key = this.value
        },
        value: function (val) {
            this.convertValue(val)
        },
    },
    created() {
        this.uploadKey =
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
    },
    mounted() {
        this.convertValue(this.value)
    },
    methods: {
        convertValue(value) {
            try {
                const obj = JSON.parse(value)
                this.key = obj.key
                this.fileName = obj.name
            } catch (err) {
                this.key = value
                this.fileName = value
            }
        },
        nextTick() {
            return new Promise(resolve => {
                this.$nextTick(() => resolve())
            })
        },
        async uploadFile(event) {
            try {
                console.log('uploadFile:', event.target.files)
                await this.$store.dispatch('js_report/fetchCredentials')
                await this.nextTick()
                const { key, name } = await this.$store.dispatch(
                    's3files/s3upload',
                    event.target.files
                )
                console.log('uploadFile: BINGO')
                this.key = key
                this.fileName = name
                await this.nextTick()
                const url = this.documentUrl
                const obj = { key, name, url }
                this.$emit('input', JSON.stringify(obj))
                this.is_visible = false
                this.doToast('Success!', 'File Uploaded!', 'success')
            } catch (err) {
                this.doToast('Error!', err.message, 'danger')
            }
        },
    },
}
</script>